//Function to calculate top margin when using background ads
calculateBackgroundAdMargin = () => {
  return (window.innerWidth / 1200) * 300
}

// sticky-ad.js
jQuery(document).ready(function ($) {


  /*
   Change global css to account for screen width when calculating background ad top margin on load
  */
  let sheet = document.styleSheets.item(0)
  if (sheet) {
    let margin = calculateBackgroundAdMargin()
    sheet.insertRule(`.newsner-body-background .single-post {margin-top: ${margin}px;}`)
    sheet.insertRule(`.newsner-body-background .share-buttons {margin-top: ${margin}px;}`)
  }




  var stickyOffset = -65;
  var stickyAdWidth = 0;
  var scrollTimeout;  // Throttle scroll event listening for sticky ad width

  if ($("body.single-post").length && $("#ad-sticky-container").length) {
    var articleBottom = $("#completedRead").first().offset().top;
    var stickyAdTop = $("#ad-sticky-container").offset().top;
    var stickyThreshold = 800;

    if ((articleBottom - stickyAdTop) > stickyThreshold) {
      $(".ad-sticky").affix({
        offset: {
          top: function () {
            return $("#ad-sticky-container").offset().top + stickyOffset
          },
          bottom: function () {
            return $(document).height() - ($("article.post").offset().top + $("article.post").height()) + stickyOffset
          }
        }
      });
    }
    ;
  };


  $("#share-buttons").affix({
    offset: {
      top: function () {
        return $(".article-layout").offset().top + stickyOffset
      },
      bottom: function () {
        return $(document).height() - ($("article.post").offset().top + $("article.post").height()) + stickyOffset
      }
    }
  });

  $("window").scroll(function () {

    $("#share-buttons").affix({
      offset: {
        top: function () {
          return $(".article-layout").offset().top + stickyOffset
        },
        bottom: function () {
          return $(document).height() - ($("article.post").offset().top + $("article.post").height()) + stickyOffset
        }
      }
    });

  });

  /*
  window.setInterval(function(){
    $(".ad-sticky").affix({
      offset: {
        top: function () {
          return $("#ad-sticky-container").offset().top + stickyOffset
        },
        bottom: function () {
          return $(document).height() - ($("article.post").offset().top + $("article.post").height()) + stickyOffset
        }
      }
    });

    $("#share-buttons").affix({
      offset: {
        top: function () {
          return $(".article-layout").offset().top + stickyOffset
        },
        bottom: function () {
          return $(document).height() - ($("article.post").offset().top + $("article.post").height()) + stickyOffset
        }
      }
    });

  }, 2000);
  */


  $(window).scroll(function () {
    //Handle top margin for sharebuttons when using background ads
    $(document.querySelector(".newsner-body-background .share-buttons"))
      .css('margin-top', `${Math.max(0, calculateBackgroundAdMargin() - document.documentElement.scrollTop)}px`)

    if (scrollTimeout) {
      // clear the timeout, if one is pending
      clearTimeout(scrollTimeout);
      scrollTimeout = null;
    }

    scrollTimeout = setTimeout(scrollHandler, 50);
  });

  $(window).resize(() => {
    //Handle top margin when using background ads
    $(document.querySelector(".newsner-body-background .single-post")).css("margin-top", `${calculateBackgroundAdMargin()}px`)
  })

  scrollHandler = function () {
    if ($('.ad-placement.affix-top').length) {
      stickyAdWidth = $('.ad-placement.affix-top').width();
    };

    if ($('.ad-placement.affix').length && stickyAdWidth) {
      $('.ad-placement.affix').css('width', stickyAdWidth);
    }
  };
});
